'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCookieDomain = getCookieDomain;
function getCookieDomain(host) {
  var parts = (host || '').split('.');
  if (parts.length < 2) {
    return;
  }

  return '.' + parts.slice(-2).join('.');
}


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/application-bootstrapper/dist/domain.js
// module id = 715
// module chunks = 118